export interface IOutage {
  id: string;
  type: ConversationalMessageType;
  creationDate: string;
  expectedSolveDate?: string;
  solveDate?: string;
  impactedProducts: ConversationalMessageProductTypesEnum[];
  telephoneNumbers?: string[];
  subscribed: boolean;
}

export enum ConversationalMessageProductTypesEnum {
  INTERNET = 'INTERNET',
  DIGITALPHONE = 'DIGITAL_PHONE',
  DIGITALTV = 'DIGITAL_TV',
  CATV = 'CATV',
  OTHER = 'OTHER',
}

export enum ConversationalMessageType {
  PORTALOUTAGE = 'PORTAL_OUTAGE',
  OUTAGE = 'OUTAGE',
  PLANNEDMAINTENANCE = 'PLANNED_MAINTENANCE',
}

export interface OutageTickets {
  outages: IOutageTicket[];
  plannedMaintenances: IPlannedMaintenance[];
}

export interface IPlannedMaintenance {
  plannedStartDate: string;
  duration: number;
}

export interface IOutageTicket {
  ticketId: string;
  createdDate: string;
  expectedResolvedDateTime?: string;
  resolvedDateTime?: string | null;
  productTypes: ConversationalMessageProductTypesEnum[];
  isResolved: boolean;
  phoneNumbers?: string[] | null;
  calculatedResolvedDateTime?: string;
}
